<script setup lang="ts">
import IconBolt from '~icons/girassol/bolt-fill'

const { t } = useI18n()
</script>

<template>
  <span
    id="tag-turbo-prime"
    class="turbo-prime-tag"
    data-testid="tag-turbo-prime"
  >
    <IconBolt
      class="turbo-prime-tag__icon"
      aria-hidden="true"
    />
    {{ t('header.project.turbo.tag') }}
  </span>
</template>

<style lang="scss" scoped>
.turbo-prime-tag {
  @apply inline-flex items-center gap-nano rounded-full px-micro py-nano mt-1;
  @apply bg-highlight-pure text-neutral-high-pure;
  @apply fonts-body-medium-regular normal-case font-sans;

  &__icon {
    @apply w-4 h-4 text-feedback-warning-pure;
  }
}
</style>
